import { env } from '#lib/env';

const SITE_KEY = env.get('VITE_GOOGLE_RECAPTCHA_V3_SITE_KEY');
const SCRIPT_URL = new URL('https://www.google.com/recaptcha/api.js');
const SCRIPT_ID = 'recaptcha-v3-script';

export const loadScript = () => {
  const existingScriptEl = document.getElementById(SCRIPT_ID);

  if (existingScriptEl) return;

  SCRIPT_URL.searchParams.set('render', SITE_KEY);

  const scriptEl = document.createElement('script');

  const scriptAttrs = {
    id: SCRIPT_ID,
    src: SCRIPT_URL.toString(),
    async: true
  };

  Object.assign(scriptEl, scriptAttrs);

  document.head.appendChild(scriptEl);
};
